import { render, staticRenderFns } from "./ProgramKerja.vue?vue&type=template&id=2f6ebf71"
import script from "./ProgramKerja.vue?vue&type=script&lang=js"
export * from "./ProgramKerja.vue?vue&type=script&lang=js"
import style0 from "./ProgramKerja.vue?vue&type=style&index=0&id=2f6ebf71&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports